module.exports = __webpack_public_path__ + "img/shiba-loading.ee43ca89.gif";